<div class="show-message">
    <app-centered-scrollable-content>

      <sc-flex vertical [centered]="true" fitHeight>
        <ng-container *ngIf="validationMessages != null && validationMessages.length > 0">
          <h2 *ngFor="let msg of validationMessages">
            <sc-dictionary-label [dictionaryKey]="msg.message"></sc-dictionary-label>
          </h2>
        </ng-container>
      </sc-flex>

    </app-centered-scrollable-content>
</div>
